import { render, staticRenderFns } from "./CommunitiesView.vue?vue&type=template&id=40133e25&"
import script from "./CommunitiesView.vue?vue&type=script&lang=js&"
export * from "./CommunitiesView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports